import { Button, Grid, Typography } from "@mui/material";
import { ModalComponent } from "../../modal";
import NotificationGif from "../../../assets/gif/notification.gif"
import { NotificationService } from "../../../services/notification";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const registerPushNotification = async (trier = 0): Promise<boolean> => {

    if (Notification.permission === "granted") {
        const applicationServerKey =
            'BLhVgloFKsBFBgvcXaHvGJxxK67GUVf4n7Uy5VOnbssvXctY9dCNlFvbROebu42FGP9SiyBls4Ftrlo-bodbhx4'

        const options = { applicationServerKey, userVisibleOnly: true }
        const registration = await navigator.serviceWorker.ready;
        try {
            const subscription = await registration.pushManager.subscribe(options);
            const { data } = await NotificationService.register(subscription);
            const deviceId = data.deviceId.toString();
            localStorage.setItem('deviceId', deviceId);
            return true
        } catch (err) {
            console.log(err);
            const waiter = new Promise((resolve) => {
                setTimeout(() => {
                    resolve(true);
                }, 5000);
            });
            await waiter;
            if (trier < 5) {
                return registerPushNotification(trier + 1);
            }

            return false
        }
    } else {
        return false
    }
}

export const ModalNotification = ({
    onClose,
    open,
    onConfirm,
}: Props) => {
    const [loading, setLoading] = useState(false)

    const handleNotification = async () => {
        setLoading(true)
        await Notification.requestPermission()

        let agree = await registerPushNotification()

        if (agree) {
            onClose()
            onConfirm()
        }

        setLoading(false)
    }

    return (
        <ModalComponent open={open} withoutHeader>
            <Grid
                width={"100%"}
                display={"flex"}
                flexDirection={"column"}
                gap={"1rem"}
            >
                <Typography fontSize={"1.4rem"}>
                    Para continuar, permita as <strong>notificações</strong> e <strong>localização</strong> do seu celular.
                </Typography>

                <Typography fontSize={"1.6rem"} fontWeight={700} mb={"-1rem"}>
                    1° Passo
                </Typography>
                <Typography fontSize={"1.4rem"} fontWeight={400} sx={{ opacity: 0.5 }}>
                    Clique no botão “Continuar” abaixo
                </Typography>

                <Typography fontSize={"1.6rem"} fontWeight={700} mb={"-1rem"}>
                    2° Passo
                </Typography>
                <Typography fontSize={"1.4rem"} fontWeight={400} sx={{ opacity: 0.5 }}>
                    Na janela que aparecer, clique em “Permitir”.
                </Typography>
            </Grid>

            <Grid
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                mt={"2.5rem"}
            >
                <img
                    src={NotificationGif}
                    width={"95%"}
                />
            </Grid>

            <Grid
                width={"100%"}
                display={"flex"}
                flexWrap={"wrap-reverse"}
                justifyContent={"center"}
                flexDirection={"row"}
                gap={"1rem"}
                mt={"2.5rem"}
            >
                <Button
                    variant="outlined"
                    sx={{
                        height: "4rem",
                        width: "14.8rem",
                        borderColor: "#79747E",
                    }}
                    onClick={onClose}
                    disabled={loading}
                >
                    Cancelar
                </Button>
                <LoadingButton
                    loading={loading}
                    variant="contained"
                    sx={{
                        height: "4rem",
                        width: "14.8rem",
                    }}
                    onClick={handleNotification}
                >
                    Continuar
                </LoadingButton>
            </Grid>

            {/* <Grid
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                mt={"1.5rem"}
                mb={"-2rem"}
            >
                <Button
                    disabled={loading}
                    variant="text"
                    sx={{
                        fontSize: "1.4rem",
                        fontWeight: 600,
                        color: "#79747E",
                        textDecoration: "underline"
                    }}
                >
                    Clicou em bloquear sem querer?
                </Button>
            </Grid> */}
        </ModalComponent>
    );
};
